import { render, staticRenderFns } from "./base-error-feedback.vue?vue&type=template&id=6147517c&"
import script from "./base-error-feedback.vue?vue&type=script&lang=js&"
export * from "./base-error-feedback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports